module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAA/CAYAAAB+WO9YAAAABHNCSVQICAgIfAhkiAAAAMBJREFUeJzt2cENAVEUheH7nhtRgerQgJXV2ChFBZZWViYqUIyJCTFPE0eu3PxfBSf/9pR+vzkbJLzZtkaPyIagYgQVI6gYQcUIKubV7BI9Iov6ej6iNwAAAAAAAAAAAOD/lWu3OkWPSKO1nZdSF9E7snCzyi8vRlAxgooRVIygYm7TdIsekcU4q0P0BgAAAAAAAAAAgB8ofbc+Ro/Iwtv74FbKMnpIHnPnRhYjqBhBxQgqRlAxL63do0dkMXxs/AKHwBuGSqMM9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/nav.png
// module id = JNxj
// module chunks = 1